+(function ($) {
	var imageLoader = function(element, options) {
		var self       = this;
		var $element   = $(element);
		var settings   = $.extend({
			force: false,
			onLoad: false,
			onAllStarted: false
		}, options);

		var imageType  = $element.data('background') ? 'bg' : 'img';
		var autoload   = $element.data('imageloader-autoload') || true;
		var imageUrl   = imageType === 'bg' ? $element.data('background') : $element.data('src');
		var timeout    = false;
		var initLoaded = false;

		this.init = function() {
			if (imageUrl == undefined) {
				if (typeof settings.onLoad == 'function') {
					settings.onLoad(this);
				}

				return;
			}

			$(window).on('resize', function() {
				initLoaded = false;
				$(window).trigger('init.imageloader');

				// if (timeout) {
				// 	clearInterval(timeout);
				// }
				//
				// // Only call loadImage() once every 500ms
				// timeout = setTimeout(function() {
				// 	self.loadImage();
				// }, 500);
			});

			$(window).on('scroll init.imageloader', function() {
				if (initLoaded) return;

				if (self.isInViewport()) {
					initLoaded = true;
					self.loadImage();
				}
			}).trigger('init.imageloader');
		};

		this.isInViewport = function() {
			var rect = element.getBoundingClientRect();

			return rect.bottom >= 0 &&
				rect.right >= 0 &&
				rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
				rect.left <= (window.innerWidth || document.documentElement.clientWidth);
		}

		this.loadImage = function() {
			self.pixelRatio    = window.devicePixelRatio || 1;
			self.elementWidth  = $element.outerWidth();
			self.elementHeight = $element.outerHeight();

			var newWidth       = getSize(self.elementWidth);
			var newHeight      = getSize(self.elementHeight);
			var currentWidth   = $element.data('imageloader-width') || 0;
			var currentHeight  = $element.data('imageloader-height') || 0;

			if (newWidth > currentWidth || newHeight > currentHeight) {
				$element.data({
					'imageloader-width': newWidth,
					'imageloader-height': newHeight
				}).addClass('imageloader-loading');

				var imageSizeUrl = imageUrl + (imageUrl.indexOf('?') >= 0 ? '&' : '?') + 'w=' + newWidth + '&h=' + newHeight + '&r=' + self.pixelRatio;
				var image        = new Image();

				if (imageType === 'img') {
					$element.data('src', imageSizeUrl);
				} else {
					$element.attr('data-background', imageSizeUrl);
				}

				$(image).on('error load', function() {
					if (autoload) {
						if (imageType === 'img') {
							$element.attr('src', imageSizeUrl);
						} else {
							$element.css('background-image', 'url(' + imageSizeUrl + ')');
						}
					}

					if (typeof settings.onLoad == 'function') {
						settings.onLoad(this);
					}
				});

				image.src = imageSizeUrl;
			}
		};

		var getSize = function(size) {
			var result = 320;

			if (size > 320)  result = 480;
			if (size > 480)  result = 768;
			if (size > 768)  result = 992;
			if (size > 992)  result = 1200;
			if (size > 1200) result = 1400;
			if (size > 1400) result = 1600;
			if (size > 1600) result = 1800;
			if (size > 1800) result = 2000;

			return result;
		}
	};

	$.fn.imageLoader = function(options) {
		return this.each(function() {
			var loader = new imageLoader(this, options);
			loader.init();
		});
	};
})(jQuery);

